var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-First-project-19x19",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)",
    fill: "#FFFFFF",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,1.77635684e-16 L9.97213731,8.85703716e-16 L15.9554197,5.74681306 L15.9554197,16 C15.9554197,17.1045695 15.0599892,18 13.9554197,18 L2,18 C0.8954305,18 1.22703893e-13,17.1045695 1.22568622e-13,16 L1.22346577e-13,2 C1.22211307e-13,0.8954305 0.8954305,2.02906125e-16 2,0 Z M8.98967274,2.00495994 L8.98967274,6.8781412 L13.9896727,6.8781412 L8.98967274,2.00495994 Z M3.98967274,9.05568744 C3.43738799,9.05568744 2.98967274,9.50340269 2.98967274,10.0556874 C2.98967274,10.6079722 3.43738799,11.0556874 3.98967274,11.0556874 L7.98967274,11.0556874 C8.54195749,11.0556874 8.98967274,10.6079722 8.98967274,10.0556874 C8.98967274,9.50340269 8.54195749,9.05568744 7.98967274,9.05568744 L3.98967274,9.05568744 Z M3.98967274,12.0556874 C3.43738799,12.0556874 2.98967274,12.5034027 2.98967274,13.0556874 C2.98967274,13.6079722 3.43738799,14.0556874 3.98967274,14.0556874 L9.98967274,14.0556874 C10.5419575,14.0556874 10.9896727,13.6079722 10.9896727,13.0556874 C10.9896727,12.5034027 10.5419575,12.0556874 9.98967274,12.0556874 L3.98967274,12.0556874 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstProject);
export default __webpack_public_path__ + "static/media/first-project.9e382b4e454d365580d2893b0f3b69ad.svg";
export { ForwardRef as ReactComponent };